import { Component, Input } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { BlankValueDashComponent } from '../blank-value-dash/blank-value-dash.component';

class AlternateNamesPatient {
  // only the payloads that carry the patient's alternate names have these
  alternateFirstNames?: string[];
  alternateLastNames?: string[];
}

@Component({
    selector: 'app-patient-alternate-names',
    templateUrl: './patient-alternate-names.component.html',
    styleUrls: ['./patient-alternate-names.component.scss'],
    imports: [NgbPopover, BlankValueDashComponent]
})
export class PatientAlternateNamesComponent {
  @Input() patient: AlternateNamesPatient;
  // a table cell reads as broken when it is empty, so it can ask for the usual dash instead
  @Input() showDashWhenEmpty = false;

  get alternateFirstNames(): string[] {
    return this.patient?.alternateFirstNames || [];
  }

  get alternateLastNames(): string[] {
    return this.patient?.alternateLastNames || [];
  }

  get hasAlternateNames(): boolean {
    return this.alternateFirstNames.length > 0 || this.alternateLastNames.length > 0;
  }
}
